import FormattedMessage from './FormattedMessage.vue'

export default FormattedMessage
